import { LoadingOutlined } from '@ant-design/icons'

export default function Loading() {
  return <div style={styles.container}>
    <LoadingOutlined />
  </div>
}

const styles = {
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}